import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { RefreshAuthResultEnum } from '../models/refresh-auth-result.enum';
import { BaseAuthService } from '../services/base-auth.service';
import { User } from '../models/user';

@Injectable()
export class AuthGuard implements CanActivate {
  private readonly authService = inject(BaseAuthService<User, unknown>);
  private readonly router = inject(Router);

  async canActivate() {
    if (!(await this.authService.isAccessTokenValid())) {
      const refreshResult = await this.authService.refreshToken();

      switch (refreshResult) {
        case RefreshAuthResultEnum.SUCCESS:
          return true;

        case RefreshAuthResultEnum.ERROR:
        case RefreshAuthResultEnum.NO_STORED:
        case RefreshAuthResultEnum.EXPIRED:
        case RefreshAuthResultEnum.PLATFORM_NOT_SUPPORTED:
          return this.router.createUrlTree(['/login']);
      }
    }

    return true;
  }
}
